// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessageRepo_DownloadChatMediaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /message_repo/downloadChatMedia
 *
 * Validates input for downloading media (images, audios, videos, documents)
 * from a chat. The four download_* flags default to true to preserve the
 * legacy behavior when callers omit them.
 */
import { registerContract } from './validate'

export interface MessageRepo_DownloadChatMediaInput {
device_key: string
chat_id: string
download_images?: boolean
download_audios?: boolean
download_videos?: boolean
download_documents?: boolean
}

registerContract('MessageRepo_DownloadChatMediaInput', {
  device_key:         { type: 'string',  required: true },
  chat_id:            { type: 'string',  required: true },
  download_images:    { type: 'boolean', required: false },
  download_audios:    { type: 'boolean', required: false },
  download_videos:    { type: 'boolean', required: false },
  download_documents: { type: 'boolean', required: false },
})
